import React, { useEffect, useState } from 'react'
import { fetchItems, fetchListItems } from '../../../../../hooks/useCrud';
import { Link } from 'react-router-dom';
import { fileUrl } from '../../../../../api/config';
import { usePagination } from '../../../../../hooks/usePagination';
import { getRelativeTime } from '../../../../../api/callApi';
import FooterGalery from './FooterGalery';

interface UiCarousel {
    id?: number;
    titre?: string;
    sousTitre?: string;
    description?: string;
    icone?: string;
    logoFile?: File;
    slug?: String;
    createdAt?: string;
    updatedAt?: string;

}

interface catBlog {
    id?: number;
    titre?: string;
}
interface UiCatBlog {
    id?: number;
    titre?: string;
    slug?: string;
    createdAt?: string;
    updatedAt?: string;
}

interface UiBlog {
    id?: number;
    titre?: string;
    sousTitre?: string;
    description?: string;
    idCategory?: number;
    status?: number;
    icone?: string;
    logoFile?: File;
    tug?: string;
    slug?: string; // string primitif
    createdAt?: string;
    updatedAt?: string;
    category_blog?: catBlog;
}





export default function BannerHome() {

    const [listData, setDataList] = useState<UiCarousel[]>([]);
    const [listDataRealisation, setDataListRealisation] = useState<UiBlog[]>([]);
    const [categories, setCategories] = useState<UiCatBlog[]>([]);
    const [listDataBlog, setDataListBlog] = useState<UiBlog[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const [randomBlogs, setRandomBlogs] = useState<UiBlog[]>([]);
    const [randomGroups, setRandomGroups] = useState<UiBlog[][]>([]);

    const [latestBlogs, setLatestBlogs] = useState<UiBlog[]>([]);
    const [latestBig, setLatestBig] = useState<UiBlog | null>(null);
    const [latestSmall, setLatestSmall] = useState<UiBlog[]>([]);

    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(3);
    const [totalPages, setTotalPages] = useState(1);
    //fin declaration

    // declaration de la pagination
    const { paginationRange, isCurrentPage, isFirstPage, isLastPage } = usePagination({
        currentPage,
        totalPages,
    });
    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiCarousel[]>('/fetch_carousel_data');
            setDataList(res.data);
            setLoading(false);
            // console.log(res);
        } finally {
            setLoading(false);
        }

    }


    const loadListDataRealisation = async () => {

        setLoading(true);
        try {
            const res = await fetchItems<UiBlog>('/fetch_realisation', {
                q: search,
                page: currentPage,
                limit,
            });
            setDataListRealisation(res.data);
            setTotalPages(res.totalPages);
            setLoading(false);
        } catch (err: any) {
            console.error(err);
            setError("Erreur lors du chargement des articles");
        } finally {
            setLoading(false);
        }
    };

    const loadListDataBlog = async () => {

        setLoading(true);
        try {
            const res = await fetchItems<UiBlog>('/fetch_blog_data', {
                q: search,
                page: currentPage,
                limit: 10,
            });
            setDataListBlog(res.data);
            setTotalPages(res.totalPages);
            setLoading(false);
        } catch (err: any) {
            console.error(err);
            setError("Erreur lors du chargement des articles");
        } finally {
            setLoading(false);
        }
    };

    const loadRandomBlogs = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiBlog[]>('/fetch_article_random'); // <-- ton endpoint
            const blogs = res.data;

            setRandomBlogs(blogs);

            // 👉 Découper en 3 groupes de 2
            const groups = [
                blogs.slice(0, 2),
                blogs.slice(2, 4),
                blogs.slice(4, 6)
            ];

            // console.log('Groupes d\'articles aléatoires :', groups);

            setRandomGroups(groups);

        } catch (err: any) {
            console.error(err);
            setError("Erreur lors du chargement des articles aléatoires");
        } finally {
            setLoading(false);
        }
    };

    const loadLatestBlogs = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiBlog[]>('/fetch_latest_articles');
            const blogs = res.data;

            setLatestBlogs(blogs);

            // 👉 1 grand + 2 petits
            setLatestBig(blogs[0] || null);
            setLatestSmall(blogs.slice(1, 3));

        } catch (err: any) {
            console.error(err);
            setError("Erreur lors du chargement des derniers articles " + err);
        } finally {
            setLoading(false);
        }
    };

    const fetchListCategorie = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiCatBlog>('/fetch_category_blog_data');
            setCategories(res.data);
        } finally {
            setLoading(false);
        }
    }



    useEffect(() => {
        fetchData();
        loadListDataRealisation();
        loadListDataBlog();
        loadRandomBlogs();
        loadLatestBlogs();
        fetchListCategorie();
    }, []);

    return (
        <div className="sportsmagazine-banner">

            {/* Wrapper start */}
            <div id="wrapper" className="wrap overflow-hidden-x">

                {/* Section start */}
                <div className="slider-panel panel swiper-parent">
                    <div className="container-full">
                        <div className="panel">
                            <div className="row g-0">
                                {/* carousel */}
                                <div className="col-12">
                                    <div className="panel w-100 text-center text-white">
                                        <div className="swiper swiper-main h-350px md:h-500px" data-uc-swiper="connect: .swiper-thumbs; active: 1; items: 1; gap: 0; dots: .swiper-pagination; disable-class: d-none;">
                                            <div className="swiper-wrapper">

                                                {
                                                    listData.length > 0 ? (
                                                        listData.map((item, index) => (


                                                            <div className="swiper-slide" key={index}>
                                                                <article className="post type-post">
                                                                    <div className="featured-image bg-gray-25 dark:bg-gray-800 ratio ratio-1x1 sm:ratio-16x9">
                                                                        <img className="media-cover image"
                                                                            src={fileUrl + "/images/" + item.icone}
                                                                            data-src={fileUrl + "/images/" + item.icone}
                                                                            alt="Victoire au tournoi régional de basketball" data-uc-img="loading: lazy" />
                                                                    </div>
                                                                    <div className="post-content py-2 sm:py-4 md:py-6 xl:py-8 md:px-4 xl:px-6 position-absolute top-0 start-0 end-0 bottom-0 z-1 vstack justify-center items-center gap-2 text-center w-100 h-100 bg-gray-900 bg-opacity-50">
                                                                        <h2 className="h4 md:h3 xl:h1 max-w-2/3 md:max-w-sm my-0 mx-auto">
                                                                            <Link to="#" className="text-none text-white">{item.titre}</Link></h2>
                                                                        <p>{item.description}</p>
                                                                        <div className="post-meta panel hstack justify-between fs-7 fw-medium text-gray-900 dark:text-white text-opacity-60 d-none md:d-flex"></div>
                                                                        <Link to="/donation" className="btn btn-sm xl:btn-md btn-primary md:mt-1 xl:mt-2 text-white">Faire un don</Link>
                                                                    </div>
                                                                </article>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="col-md-12">
                                                            <p>Aucune donnée disponible</p>
                                                        </div>
                                                    )
                                                }



                                            </div>

                                            {/* Add Pagination */}
                                            <div className="swiper-pagination mb-2 md:mb-3 xl:mb-4 text-white d-none md:d-inline-flex"></div>

                                            {/* Add Arrows */}
                                            <div className="swiper-nav swiper-next btn btn-xs md:btn-md p-0 w-32px md:w-40px xl:w-56px h-32px md:h-40px xl:h-56px bg-white text-dark rounded-circle shadow-xs position-absolute top-50 end-0 translate-middle-y me-narrow md:me-4 z-1">
                                                <i className="fa fa-chevron-right icon-1 md:icon-2"></i>
                                            </div>
                                            <div className="swiper-nav swiper-prev btn btn-xs md:btn-md p-0 w-32px md:w-40px xl:w-56px h-32px md:h-40px xl:h-56px bg-white text-dark rounded-circle shadow-xs position-absolute top-50 start-0 translate-middle-y ms-narrow md:ms-4 z-1">
                                                <i className="fa fa-chevron-left icon-1 md:icon-2"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* fin carousel */}

                                {/* nos realisations */}
                                <div className="col-12">
                                    <div className="panel bg-gray-25 dark:bg-gray-100 dark:bg-opacity-15">
                                        <div className="swiper swiper-thumbs" data-uc-swiper="items: 1.5; gap: 0; mousewheel: true; freeMode: true; center: true; center-bounds: true;" data-uc-swiper-s="items: 3;" data-uc-swiper-m="items: 4; center: false; center-bounds: false;">
                                            <div className="swiper-wrapper">


                                                {
                                                    listDataRealisation.length > 0 ? (
                                                        listDataRealisation.map((item, index) => (

                                                            <div className="swiper-slide" key={index}>
                                                                <article className="post type-post p-1 md:p-2 xl:p-3">
                                                                    <div className="row g-0">
                                                                        <div className="w-56px xl:w-64px">
                                                                            <figure className="featured-image m-0 ratio ratio-1x1 uc-transition-toggle overflow-hidden bg-gray-25 dark:bg-gray-800">
                                                                                <img className="media-cover image uc-transition-scale-up uc-transition-opaque"
                                                                                    src={fileUrl + "/images/" + item.icone}
                                                                                    data-src={fileUrl + "/images/" + item.icone}
                                                                                    alt="Victoire au tournoi régional de basketball"
                                                                                    data-uc-img="loading: lazy" />
                                                                            </figure>
                                                                        </div>
                                                                        <div className="col ms-1 md:ms-2">
                                                                            <h4 className="h6 m-0 text-truncate-3">
                                                                                <Link to={"/realisation/" + item.slug} className="text-none hover:text-primary duration-150">
                                                                                    {item.titre}
                                                                                </Link>
                                                                            </h4>
                                                                        </div>
                                                                    </div>
                                                                </article>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="col-md-12">
                                                            <p>Aucune donnée disponible</p>
                                                        </div>
                                                    )
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* fin nos realisations */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* blog article */}
                {/* Section start */}
                <div className="section panel overflow-hidden-x">
                    <div className="section-outer panel pt-4 md:pt-6 lg:pt-8 xl:pt-9">
                        <div className="container max-w-2xl p-0 sm:px-2 lg:px-4 xl:px-0">
                            <div className="section-inner panel vstack gap-0 sm:gap-2 xl:gap-3">

                                <div className="sticky-col-1 panel">
                                    <div className="row child-cols-12 lg:child-cols g-3 col-match" data-uc-grid>


                                        {/* debit */}
                                        <div>
                                            <div className="row child-cols-12 lg:child-cols g-0 sm:g-2 xl:g-3 col-macth">

                                                {/* --------------------------
                                                    BIG ARTICLE (LEFT)
                                                --------------------------- */}
                                                {latestBig && (
                                                    <div>
                                                        <article className="post type-post panel vstack overflow-hidden h-100 bg-white dark:bg-gray-900">
                                                            <div className="post-media panel overflow-hidden">
                                                                <figure className="featured-image m-0 ratio ratio-16x9">
                                                                    <img
                                                                        className="media-cover image"
                                                                        src={fileUrl + "/images/" + latestBig.icone}
                                                                        alt={latestBig.titre}
                                                                    />
                                                                    <Link to={`/blog/${latestBig.slug}`} className="position-cover"></Link>
                                                                </figure>
                                                            </div>

                                                            <div className="post-header panel vstack justify-between gap-3 p-2 sm:p-3">
                                                                <div className="post-top panel vstack items-start gap-1 xl:gap-2 mb-1 sm:mb-0">
                                                                    <div className="post-meta panel fs-7 px-narrow border">
                                                                        <div className="post-category hstack gap-narrow fw-semibold">
                                                                            <span>{latestBig.category_blog?.titre}</span>
                                                                        </div>
                                                                    </div>

                                                                    <h3 className="post-title h4 xl:h3 m-0 text-truncate-2">
                                                                        <Link className='hover:text-primary duration-150' to={`/blog/${latestBig.slug}`} style={{ textDecoration: "none" }}>{latestBig.titre}</Link>
                                                                    </h3>

                                                                    <p className="fs-6 sm:fs-5 text-truncate-3">
                                                                        {latestBig.sousTitre}
                                                                    </p>

                                                                    <div>
                                                                        {latestBig.tug
                                                                            ?.split(",")
                                                                            .map((mot) => mot.trim())
                                                                            .filter((mot) => mot.length > 0)
                                                                            .map((mot, index) => (
                                                                                <span key={index} className="badge rounded-pill bg-primary me-1 mb-1">
                                                                                    {mot}
                                                                                </span>
                                                                            ))}
                                                                    </div>
                                                                </div>

                                                                <div className="post-bottom panel hstack gap-2 fs-7 mt-narrow sm:mt-0 text-black dark:text-white text-opacity-60">
                                                                    <div>
                                                                        <div className="post-date hstack gap-narrow">
                                                                            <i className="fas fa-clock" tabIndex={0}></i>
                                                                            <span>Publiée: {getRelativeTime(latestBig.createdAt ?? "")} </span>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </article>
                                                    </div>
                                                )}

                                                {/* --------------------------
                                                    2 SMALL ARTICLES (RIGHT)
                                                --------------------------- */}

                                                <div className="lg:col-4">
                                                    <div className="panel">
                                                        <div className="row child-cols-12 sm:child-cols-6 lg:child-cols-12 g-0 sm:g-2 xl:g-3">

                                                            {latestSmall.map((item) => (
                                                                <div key={item.id}>
                                                                    <article className="post type-post panel hstack sm:vstack items-start gap-2 bg-white dark:bg-gray-900 p-2">
                                                                        <div className="post-media panel overflow-hidden w-200px sm:w-100">
                                                                            <figure className="featured-image m-0 ratio ratio-3x2">
                                                                                <img
                                                                                    className="media-cover image"
                                                                                    src={fileUrl + "/images/" + item.icone}
                                                                                    alt={item.titre}
                                                                                />
                                                                                <Link to={`/blog/${item.slug}`} className="position-cover" ></Link>
                                                                            </figure>
                                                                        </div>

                                                                        <div className="post-header panel vstack justify-between w-100 p-2">
                                                                            <div className="post-top panel vstack items-start gap-2">
                                                                                <div className="post-meta panel fs-7 px-narrow border text-truncate-2">
                                                                                    <span>{item.category_blog?.titre}</span>
                                                                                </div>

                                                                                <h3 className="post-title h6 sm:h5 m-0 text-truncate-2">
                                                                                    <Link className='hover:text-primary duration-150' to={`/blog/${item.slug}`} style={{ textDecoration: "none" }}>{item.titre}</Link>
                                                                                </h3>
                                                                                <p className="fs-6 sm:fs-5 text-truncate-3">
                                                                                    {item.sousTitre}
                                                                                </p>
                                                                            </div>



                                                                            <div className="post-bottom panel hstack gap-2 fs-7 mt-narrow sm:mt-0 text-black dark:text-white text-opacity-60">
                                                                                <div>
                                                                                    <div className="post-date hstack gap-narrow">
                                                                                        <i className="fas fa-clock" tabIndex={0}></i>
                                                                                        <span>Publiée: {getRelativeTime(item.createdAt ?? "")} </span>
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </article>
                                                                </div>
                                                            ))}

                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        {/* fin */}



                                        <div className="col-3 d-none xl:d-block">
                                            <div className="sidebar-wrap panel" data-uc-sticky="end: .sticky-col-1; offset: 85; media: @m;">

                                                <FooterGalery />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="panel">
                                    <div className="row child-cols-12 sm:child-cols-6 lg:child-cols-4 xl:child-cols-3 g-0 sm:g-2 xl:g-3 col-match uc-grid" data-uc-grid="">
                                        {/* liste verticlale de blog */}
                                        <div className="order-2 sm:order-1 uc-first-column">
                                            <div className="list-layout panel p-2 pb-3 sm:p-2 mt-2 sm:mt-0 bg-white dark:bg-gray-900">
                                                <div className="list-header panel mb-2 hstack justify-between ga-2">
                                                    <h2 className="list-title h5 m-0 hstack gap-1">
                                                        <i className="icon icon-narrow fa fa-basketball-ball text-primary"></i>
                                                        <span>Activités <span className="text-primary">récentes</span></span>
                                                    </h2>
                                                    <a href="actualites.html" className="link fs-6 fw-bold text-uppercase text-none gap-1 mt-narrow sm:mt-1 hover:text-gray-900 dark:hover:text-white duration-200 sm:d-none">
                                                        <span>Voir tout</span>
                                                    </a>
                                                </div>
                                                <div className="list-content panel overflow-auto h-400px sm:h-700px lg:h-600px xl:h-550px">
                                                    <div className="row sep-x gy-2 gx-4 me-1 uc-grid uc-grid-stack" data-uc-grid="">
                                                        {
                                                            listDataBlog.length > 0 ? (
                                                                listDataBlog.map((item, index) => (

                                                                    <div className="uc-grid-margin uc-first-column" key={index}>
                                                                        <article className="post type-post panel vstack pb-narrow text-gray-900 dark:text-white">
                                                                            <div>
                                                                                <span className="time fs-7 opacity-60">{getRelativeTime(item.createdAt ?? "")}</span>
                                                                            </div>
                                                                            <h6 className="fs-5 text-truncate-2">
                                                                                <Link className="text-none hover:text-primary duration-150" to={`/blog/${item.slug}`}>{item.titre}</Link>
                                                                            </h6>
                                                                        </article>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div className="col-md-12">
                                                                    <p>Aucune donnée disponible</p>
                                                                </div>
                                                            )
                                                        }


                                                    </div>
                                                </div>
                                                <div className="list-footer panel mt-3 text-center d-none sm:d-block">
                                                    <Link to="/blogs" className="link fs-6 fw-bold text-uppercase text-none gap-1 mt-1 hover:text-gray-900 dark:hover:text-white duration-200">
                                                        <span>Voir toutes les activités</span>
                                                        <i className="icon-1 fa fa-arrow-right"></i>
                                                    </Link>
                                                </div>

                                                <div className='row child-cols-12 mt-2'>
                                                    <div className='text-center'>
                                                        <h3 className="h5 m-0 text-primary mb-2"><i className="fas fa-tags"></i> Catégories</h3>
                                                        
                                                        <span>Explorez nos catégories</span>
                                                    </div>

                                                    {
                                                        categories.map((item, index) => (
                                                            <div key={index} className='lg:col-6 xl:col-6 mb-2'>
                                                                <Link to={'/category/' + item.slug}>
                                                                    <span className="badge rounded-pill bg-primary me-1 mb-1">
                                                                        {item.titre}
                                                                    </span>

                                                                </Link>

                                                            </div>


                                                        ))
                                                    }
                                                </div>


                                            </div>
                                        </div>
                                        {/* fin liste verticlale de blog */}
                                        {/* liste horizontale de blog */}

                                        {randomGroups.map((group, index) => (
                                            <div key={index} className="order-1 sm:order-1 uc-grid-margin">
                                                <div className="panel">
                                                    <div className="row child-cols-12 g-0 sm:g-2 xl:g-3">

                                                        {group.map((item) => (
                                                            <div key={item.id}>
                                                                <article className="post type-post panel hstack sm:vstack items-start gap-2 sm:gap-0 p-2 sm:p-0 bg-white dark:bg-gray-900">

                                                                    <div className="post-media panel overflow-hidden w-200px sm:w-100 order-1 sm:order-0">
                                                                        <figure className="featured-image m-0 ratio ratio-3x2 sm:ratio-16x9">
                                                                            <img
                                                                                className="media-cover image"
                                                                                src={fileUrl + "/images/" + item.icone}
                                                                                alt={item.titre}
                                                                            />
                                                                        </figure>
                                                                    </div>

                                                                    <div className="post-header panel vstack justify-between p-2 w-100">
                                                                        <div className="post-top panel vstack items-start gap-1">
                                                                            <div className="post-meta btn-primary panel fs-7 border px-1">
                                                                                <span>{item.category_blog?.titre}</span>
                                                                            </div>


                                                                            <h3 className="post-title h6 m-0 text-truncate-2">
                                                                                <Link to={"/blog/" + item.slug} style={{ textDecoration: "none" }}>
                                                                                    {item.titre}
                                                                                </Link>
                                                                            </h3>

                                                                            <p>
                                                                                {item.sousTitre}
                                                                            </p>

                                                                            <div>
                                                                                {item.tug
                                                                                    ?.split(",")
                                                                                    .map((mot) => mot.trim())
                                                                                    .filter((mot) => mot.length > 0)
                                                                                    .map((mot, index) => (
                                                                                        <span key={index} className="badge rounded-pill bg-primary me-1 mb-1">
                                                                                            {mot}
                                                                                        </span>
                                                                                    ))}
                                                                            </div>
                                                                        </div>

                                                                        <div className="post-bottom panel hstack gap-2 fs-7 mt-narrow sm:mt-0 text-black dark:text-white text-opacity-60">
                                                                            <div>
                                                                                <div className="post-date hstack gap-narrow">
                                                                                    <i className="fas fa-clock" tabIndex={0}></i>
                                                                                    <span>Publiée: {getRelativeTime(item.createdAt ?? "")} </span>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                </article>
                                                                <br />
                                                            </div>
                                                        ))}

                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {/* fin liste horizontale de blog */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Section end */}
                {/* fin bloc */}

                {/* Les sections suivantes seraient adaptées de la même manière */}
                {/* En remplaçant les titres, descriptions et catégories par du contenu adapté au Diocèse de Goma */}
                {/* Tout en conservant la structure HTML et les URLs des images */}

            </div>

            {/* Wrapper end */}




        </div>
    )
}
